import React, { useEffect, useState } from 'react'
import { api } from '../../app/Api/ApiSlice'
import { useParams } from 'react-router-dom'
import { toast } from 'react-toastify'
import Loader from '../../components/Loader' 
import "./storesStyles.css"

const StoreAddress = () => {
    const [address, setAddress] = useState({})
    const [isLoading, setIsLoading] = useState(false)

    const { name } = useParams()

    useEffect(() => {
        const getAddress = async () => {
            try {
                setIsLoading(true)
                const response = await api.get(`/stores/${name}/address`)
                if (response?.data) {
                    setAddress(response.data.address)
                }
            } catch (error) {
                toast.error(error?.response?.data?.message || 'Failed to fetch address')
            } finally {
                setIsLoading(false)
            }
        }

        getAddress()
    }, [name])

    if (isLoading) return <Loader />

    if (!address) return <p className="no-address">No address found.</p>

    return (
        <div className="store-address-container">
            <h2 className="title">Store Address</h2>
            <div className="address-details">
                <div><span className="label">Building:</span> {address.building}</div>
                <div><span className="label">Room:</span> {address.room}</div>
                <div><span className="label">Street:</span> {address.street}</div>
                <div><span className="label">City:</span> {address.city}</div>
                <div><span className="label">State:</span> {address.state}</div>
                <div><span className="label">Country:</span> {address.country}</div>
            </div>
        </div>
    )
}

export default StoreAddress
